import React from 'react';
import ContentLoader from 'react-content-loader';

export const ListLoadingSkelton = () => {
  return (
    <div className="flex items-center bg-white mb-2 p-2">
      <ContentLoader width="100%" height={40}>
        <rect x="0" y="4" rx="32" ry="32" width="32" height="32" />
        <rect x="40" y="4" rx="0" ry="0" width="240" height="32" />
      </ContentLoader>
    </div>
  );
};

export const OrgNameLoadingSkelton = () => {
  return (
    <div className="flex items-center w-[200px]">
      <ContentLoader height={40}>
        <rect x="0" y="0" rx="40" ry="40" width="40" height="40" />
        <rect x="48" y="10" rx="0" ry="0" width="140" height="20" />
      </ContentLoader>
    </div>
  );
};
